/* eslint-disable react-hooks/exhaustive-deps */
import { Edit } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, FormControl, Grid, InputLabel, Link, OutlinedInput, styled, Typography } from "@mui/material";
import BusinessIcon from '@mui/icons-material/Business';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import SellIcon from '@mui/icons-material/Sell';
import ApartmentIcon from '@mui/icons-material/Apartment';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import ViewComfyIcon from '@mui/icons-material/ViewComfy';
import { useEffect, useState } from "react";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../../../common/common";
import { LoadingPage } from "../../../../common/LoadingPage";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ActionStage, CurrencyJSON, ItemStatus } from "../../../../common/const";
import moment from "moment";
import ItemDetails from "./ItemDetails";
import EditItem from "./EditItem/EditItem";
import { useSelector } from "react-redux";

const DemoTypo = styled(Typography)(({ theme }) => ({
    color: 'gray',
    fontSize: 13
}));

const DemoTypo1 = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: 13
}));

const ReviewItemModule = ({
    projectData,
    item,
    setActiveTab,
    setBuilding,
    setLevel,
    setDepartment,
    setRoom,
    setItem
}) => {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const [dataLoading, setDataLoading] = useState(false);
    const [itemData, setItemData] = useState(null);
    const [itemTotal, setItemTotal] = useState(0);
    const [commentOpen, setComment] = useState(false);
    const [notes, setNotes] = useState(null);
    const [open, setOpen] = useState(false);
    const [additionalTax, setAdditionalTax] = useState(0);

    const getInitialData = async () => {
        setDataLoading(true);
        try {
            const response = await apiRequest('get', `/project-item/${item?.item_id}`);
            const { data } = response.data;
            if (data) {
                setNotes(data?.notes);
                const subTotal = data?.quantity * data?.unit_price;
                const tax = ((data?.quantity * data?.unit_price) * Number((!projectData?.is_tax_exempt ? data?.tax : 0))) / 100;
                let additionalTax = 0;
                const taxableOption = projectData?.taxable_option !== undefined ? JSON.parse(projectData?.taxable_option) : null;
                if (taxableOption?.length > 0) {
                    if (taxableOption.includes('Freight')) {
                        additionalTax = additionalTax + ((Number(data?.freight) * projectData?.tax_rate) / 100);
                    }
                    if (taxableOption.includes('Installation')) {
                        additionalTax = additionalTax + ((Number(data?.installation) * projectData?.tax_rate) / 100);
                    }
                    if (taxableOption.includes('Storage')) {
                        additionalTax = additionalTax + ((Number(data?.storage) * projectData?.tax_rate) / 100);
                    }
                    if (taxableOption.includes('Fees')) {
                        additionalTax = additionalTax + ((Number(data?.fees) * projectData?.tax_rate) / 100);
                    }
                }
                setAdditionalTax(additionalTax);
                setItemTotal(subTotal + tax + Number(data?.freight) + Number(data?.installation) + Number(data?.fees) + Number(data?.storage) - Number(data?.discounts) - Number(data?.tradein) + Number(additionalTax));
                setItemData(data);
                setDataLoading(false);
            }
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }
    useEffect(() => {
        if (item?.item_id) {
            getInitialData();
        }
    }, [item, projectData]);

    return (
        <Box component="main" mt={0.5}>
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            {open && (
                <EditItem
                    open={open}
                    setOpen={setOpen}
                    itemData={itemData}
                    projectData={projectData}
                    getInitialData={getInitialData}
                />
            )}
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6">{itemData?.product_data?.model ? itemData?.product_data?.model : item?.product?.model !== 'null' ? item?.product?.model : 'UnSpecified'}</Typography>
                {isUser?.code !== 'orgGuestUser' && (<Button
                    size="small"
                    variant="contained"
                    color="primary"
                    startIcon={<Edit />}
                    style={{
                        textTransform: 'capitalize'
                    }}
                    disabled={itemData?.stage === 'purchased'}
                    onClick={() => setOpen(true)}
                >
                    Edit Item
                </Button>)}
            </Box>
            <Box style={{
                background: ' #d1e9f1',
                padding: '5px 0px 5px 25px',
                margin: '10px -24px 0px -24px',
                display: 'flex',
                alignItems: 'center',
                gap: 10
            }}>
                <Link
                    style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                    color="inherit"
                >
                    Project Hierarchy :
                </Link>
                <Box display="flex" alignItems="center" gap={0.5}>
                    <BusinessIcon style={{ fontSize: 18, color: 'gray' }} />
                    <Link
                        style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                        color="inherit"
                        onClick={() => {
                            setActiveTab('Details');
                            setBuilding(null);
                            setLevel(null);
                            setDepartment(null);
                            setRoom(null);
                            setItem(null);
                            localStorage.removeItem('itemData');
                        }}
                    >
                        {projectData?.name}
                    </Link>
                </Box>
                {item?.building !== null && (
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <LocationCityIcon style={{ fontSize: 18, color: 'gray' }} />
                        <Link
                            style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                            color="inherit"
                            onClick={() => {
                                setActiveTab('Buildings');
                                setBuilding(null);
                                setLevel(null);
                                setDepartment(null);
                                setRoom(null);
                                setItem(null);
                                localStorage.setItem('search', item?.building?.building_name);
                                localStorage.removeItem('itemData');
                            }}
                        >
                            {item?.building?.building_name}
                        </Link>
                    </Box>
                )}
                {item?.level !== null && (
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <ApartmentIcon style={{ fontSize: 18, color: 'gray' }} />
                        <Link
                            style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                            color="inherit"
                            onClick={() => {
                                setActiveTab('Levels');
                                setBuilding(null);
                                setLevel(null);
                                setDepartment(null);
                                setRoom(null);
                                setItem(null);
                                localStorage.setItem('search', item?.level?.level_name);
                                localStorage.removeItem('itemData');
                            }}
                        >
                            {item?.level?.level_name}
                        </Link>
                    </Box>
                )}
                {item?.department !== null && (
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <ViewComfyIcon style={{ fontSize: 18, color: 'gray' }} />
                        <Link
                            style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                            color="inherit"
                            onClick={() => {
                                setActiveTab('Departments');
                                setBuilding(null);
                                setLevel(null);
                                setDepartment(null);
                                setRoom(null);
                                setItem(null);
                                localStorage.setItem('search', item?.department?.department_name);
                                localStorage.removeItem('itemData');
                            }}
                        >
                            {item?.department?.department_name}
                        </Link>
                    </Box>
                )}
                {item?.room !== null && (
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <MeetingRoomIcon style={{ fontSize: 18, color: 'gray' }} />
                        <Link
                            style={{ textDecoration: 'none', cursor: 'pointer', fontSize: 12, color: 'gray' }}
                            color="inherit"
                            onClick={() => {
                                setActiveTab('Rooms');
                                setBuilding(null);
                                setLevel(null);
                                setDepartment(null);
                                setRoom(null);
                                setItem(null);
                                localStorage.setItem('search', item?.room?.room_name);
                                localStorage.removeItem('itemData');
                            }}
                        >
                            {item?.room?.room_name}
                        </Link>
                    </Box>
                )}
                <Box display="flex" alignItems="center" gap={0.5}>
                    <SellIcon color="primary" style={{ fontSize: 16 }} />
                    <Typography color="primary" style={{ fontSize: 12 }}>{itemData?.product_data?.model ? itemData?.product_data?.model : item?.product?.model !== 'null' ? item?.product?.model !== null ? item?.product?.model : 'UnSpecified' : 'UnSpecified'}</Typography>
                </Box>
            </Box>
            <Grid container spacing={2} mt={0.3}>
                <Grid item xs={12} sm={12} lg={9}>
                    <ItemDetails
                        itemData={itemData}
                        projectData={projectData}
                        getInitialData={getInitialData}
                    />
                </Grid>
                <Grid item xs={12} sm={12} lg={3}>
                    <Accordion defaultExpanded>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Typography style={{ fontWeight: 'bold' }}>Important Details</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <DemoTypo>Status</DemoTypo>
                                <DemoTypo1>{ItemStatus?.find((a) => a.value === itemData?.status)?.name || '--'}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <DemoTypo>Stage</DemoTypo>
                                <DemoTypo1>{ActionStage?.find((a) => a.value === itemData?.stage)?.name || '--'}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <DemoTypo>State</DemoTypo>
                                <DemoTypo1>{itemData?.is_deleted ? 'InActive' : 'Active'}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <DemoTypo>Need By Date</DemoTypo>
                                <DemoTypo1>{itemData?.need_by_date ? moment(itemData?.need_by_date).format('YYYY-MM-DD') : '--'}</DemoTypo1>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Box display="flex" justifyContent="space-between" alignItems="center" style={{ width: '100%' }}>
                                <Typography style={{ fontWeight: 'bold' }}>Item Total</Typography>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} 
                                    ${itemTotal ? Intl.NumberFormat('en-IN').format(itemTotal) : 0}`}
                                </DemoTypo1>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <DemoTypo>Price</DemoTypo>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.unit_price ? Intl.NumberFormat('en-IN').format(itemData?.unit_price) : 0}`}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                <DemoTypo>Quantity</DemoTypo>
                                <DemoTypo1>{itemData?.quantity || 0}</DemoTypo1>
                            </Box>
                            <Divider />
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '5px' }}>
                                <DemoTypo>Item Sub Total</DemoTypo>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.unit_price ? Intl.NumberFormat('en-IN').format(itemData?.unit_price * itemData?.quantity) : 0}`}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                <DemoTypo>{`Item SubTotal Tax (${itemData?.tax}%)`}</DemoTypo>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.unit_price ? Intl.NumberFormat('en-IN').format(((itemData?.unit_price * itemData?.quantity) * (!projectData?.is_tax_exempt ? itemData?.tax : 0)) / 100) : 0}`}</DemoTypo1>
                            </Box>
                            <Divider />
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '5px' }}>
                                <DemoTypo>Freight</DemoTypo>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.freight ? Intl.NumberFormat('en-IN').format(itemData?.freight) : 0}`}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <DemoTypo>Storage</DemoTypo>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.storage ? Intl.NumberFormat('en-IN').format(itemData?.storage) : 0}`}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <DemoTypo>Installation</DemoTypo>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.installation ? Intl.NumberFormat('en-IN').format(itemData?.installation) : 0}`}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <DemoTypo>Fees</DemoTypo>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.fees ? Intl.NumberFormat('en-IN').format(itemData?.fees) : 0}`}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <DemoTypo>Discount</DemoTypo>
                                <DemoTypo1 style={{ color: 'red' }}>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.discounts ? Intl.NumberFormat('en-IN').format(itemData?.discounts) : 0}`}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                <DemoTypo>Trade-In</DemoTypo>
                                <DemoTypo1 style={{ color: 'red' }}>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.tradein ? Intl.NumberFormat('en-IN').format(itemData?.tradein) : 0}`}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                                <DemoTypo>{`Additional Tax (${projectData?.tax_rate}%)`}</DemoTypo>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${additionalTax ? Intl.NumberFormat('en-IN').format(additionalTax) : 0}`}</DemoTypo1>
                            </Box>
                            <Divider />
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '5px' }}>
                                <DemoTypo>Item Tax</DemoTypo>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.unit_price ? Intl.NumberFormat('en-IN').format((((itemData?.unit_price * itemData?.quantity) * (!projectData?.is_tax_exempt ? itemData?.tax : 0)) / 100) + additionalTax) : (0 + additionalTax)}`}</DemoTypo1>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <DemoTypo>Item Total</DemoTypo>
                                <DemoTypo1>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} 
                                    ${itemTotal ? Intl.NumberFormat('en-IN').format(itemTotal) : 0}`}
                                </DemoTypo1>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion defaultExpanded>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Typography style={{ fontWeight: 'bold' }}>Item Comments</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {commentOpen ? (
                                <>
                                    <FormControl size="small" variant="outlined" fullWidth>
                                        <InputLabel htmlFor="standard-adornment-password">Comment</InputLabel>
                                        <OutlinedInput
                                            multiline
                                            maxRows={5}
                                            minRows={4}
                                            label="Comment"
                                            id="standard-adornment-password"
                                            type='text'
                                            value={notes || ''}
                                            onChange={(e) => {
                                                setNotes(e.target.value);
                                            }}
                                        />
                                    </FormControl>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        fullWidth
                                        size="small"
                                        disabled={!notes}
                                        style={{
                                            marginTop: '8px',
                                            fontWeight: 'bold',
                                            textTransform: 'capitalize'
                                        }}
                                        onClick={async () => {
                                            setDataLoading(true);
                                            try {
                                                const response = await apiRequest('put', `/project-item/${item?.item_id}`, {
                                                    notes: notes,
                                                });
                                                const { data } = response.data;
                                                if (data) {
                                                    setComment(false);
                                                    setNotes(null);
                                                    getInitialData();
                                                    setDataLoading(false);
                                                    showNotification('Comment added successfully', 'success');
                                                }
                                            } catch (error) {
                                                setDataLoading(false);
                                                showNotification(error?.response?.data.error || error.message, 'error');
                                            }
                                            setComment(false);
                                            setNotes(null);
                                        }}
                                    >
                                        Save Comment
                                    </Button>
                                </>
                            ) : isUser?.code !== 'orgGuestUser' && (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    fullWidth
                                    size="small"
                                    style={{
                                        marginTop: '8px',
                                        fontWeight: 'bold',
                                        textTransform: 'capitalize'
                                    }}
                                    onClick={() => {
                                        setComment(true);
                                    }}
                                >
                                    {notes ? 'Update Comment' : 'Add Comment'}
                                </Button>)}
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>
        </Box>
    )
}

export default ReviewItemModule;